import { Inject, Injectable } from '@angular/core';

import { DeviceType } from 'app.config';
import { RenderConfigurationService } from 'render/services/render-configuration.service';


@Injectable()
export class RenderByDeviceService {

  constructor(
    private readonly renderConfigurationService: RenderConfigurationService,
    @Inject('Window') private readonly window: Window
  ) { }

  public get isMobile(): boolean {
    const bpMobile = this.renderConfigurationService.config.breakpoints.find(
      (breakpoint) => breakpoint.device.includes(DeviceType.MOBILE)
    );
    return bpMobile !== undefined && this.window.matchMedia(bpMobile.bp).matches;
  }

}
